import { IconButton, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as actions from '../../../../locations/actions'
import MenuIcon from '@material-ui/icons/Menu'
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import DeviceHubIcon from '@material-ui/icons/SettingsRemoteOutlined'
import PlaceOutlineIcon from '@material-ui/icons/PlaceOutlined'
import ShareIcon from '@material-ui/icons/Share'

import cl from 'classnames'
import Dropdown from '../dropdown'
import { UserPermissions } from 'web/src/services/permissions'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
    locationsTreeLabelMenuIconWrapper: {
        position: 'relative'
    },
    locationsTreeLabelMenuIconButton: {
        position: 'relative'
    },
    locationsTreeLabelMenuIconButtonClicked: {
        position: 'relative',
        display: 'inline-flex !important'
    },
    locationsTreeLabelMenuIconSelected: {
        color: theme.textPrimaryReverted,
        width: 18,
        height: 18,
        '&:hover': {
            color: theme.secondary
        }
    },
    locationsTreeLabelMenuIcon: {
        color: theme.textPrimary,
        width: 18,
        height: 18
    },
    locationDropdown: {
        cursor: 'auto'
    },
    locationDropdownIcon: {
        marginRight: 8,
        width: 15,
        height: 15
    },
    locationDropdownItem: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 100,
        marginLeft: -12,
        marginRight: -12,
        padding: '8px 12px 8px 12px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.secondary
        }
    },
    locationDropdownIconWrapper: {
        display: 'flex'
    }
}))

export const MenuIconWithDropdown = React.memo(props => {
    const classes = useStyles()
    const [activeLocationDropdown, setActiveLocationDropdown] = useState(null)
    const {
        permissions,
        location,
        isSelected,

        onLocationLabelClick,

        setIsDevicesToMoveMode,
        setIsNetworkDevicesToMoveMode,
        locale,
        onAddSubLocation,
        setIsDeleteLocationsModalOpen,
        setLocationsToDelete,
        disabled,
        pickerLocations,
        setIsLocationCreateModalOpen
    } = props

    const locationId = location.id
    const itemRef = React.useRef()
    const history = useHistory()
    const can = {
        create: permissions.createLocation(location.customer_id),
        delete: permissions.deleteLocation(location.customer_id),
        update: permissions.updateLocation(location.customer_id),
        share: permissions.share(location.customer_id)
    }

    const dispatch = useDispatch()

    const onMenuIconClick = locationId => e => {
        e.stopPropagation()
        setActiveLocationDropdown(locationId)
    }

    const closeDropdown = () => {
        setActiveLocationDropdown(null)
    }

    const handleAddSubLocation = e => {
        e.stopPropagation()
        if (setIsLocationCreateModalOpen) {
            setIsLocationCreateModalOpen(true)
        }
        setActiveLocationDropdown(null)
    }

    const onAddDevicesClick = locationId => e => {
        e.stopPropagation()
        setActiveLocationDropdown(null)
        onLocationLabelClick(locationId)
        dispatch(
            actions.availableDevicesRequest(locationId, location.customer_id)
        )
        setIsDevicesToMoveMode(true)
    }

    const onDeleteLocationClick = locationId => e => {
        e.stopPropagation()
        setIsDeleteLocationsModalOpen(true)
        setLocationsToDelete([
            { id: locationId, customer_id: location.customer_id }
        ])
    }

    const handleLocationShare = locationId => e => {
        e.stopPropagation()
        history.push(`/locations/${locationId}/share-info?isShare=1`)
        setLocationsToDelete([
            { id: locationId, customer_id: location.customer_id }
        ])
    }

    const isDropdownOpen = activeLocationDropdown === locationId

    return (
        <div className={classes.locationsTreeLabelMenuIconWrapper}>
            {locationId !== 'new' && (
                <IconButton
                    size="small"
                    ref={itemRef}
                    disabled={disabled}
                    onClick={onMenuIconClick(locationId)}
                    className={cl({
                        [classes.locationsTreeLabelMenuIconButton]: true,
                        [classes.locationsTreeLabelMenuIconButtonClicked]:
                            activeLocationDropdown === locationId
                    })}>
                    <MenuIcon
                        className={
                            isSelected
                                ? classes.locationsTreeLabelMenuIconSelected
                                : classes.locationsTreeLabelMenuIcon
                        }
                    />
                </IconButton>
            )}
            {isDropdownOpen && (
                <Dropdown
                    isOpen={isDropdownOpen}
                    className={classes.locationDropdown}
                    close={closeDropdown}
                    anchorEl={itemRef.current}>
                    {can.create && (
                        <div
                            className={classes.locationDropdownItem}
                            onClick={handleAddSubLocation}>
                            <div
                                className={classes.locationDropdownIconWrapper}>
                                <PlaceOutlineIcon
                                    className={classes.locationDropdownIcon}
                                />
                            </div>
                            <div>{locale.locations.addSubLocation}</div>
                        </div>
                    )}
                    {can.update && (
                        <div
                            className={classes.locationDropdownItem}
                            onClick={onAddDevicesClick(locationId)}>
                            <div
                                className={classes.locationDropdownIconWrapper}>
                                <DeviceHubIcon
                                    className={classes.locationDropdownIcon}
                                />
                            </div>
                            <div>{locale.locations.addDevices}</div>
                        </div>
                    )}
                    {can.delete && location?.parent_id && (
                        <div
                            className={classes.locationDropdownItem}
                            onClick={onDeleteLocationClick(locationId)}>
                            <div
                                className={classes.locationDropdownIconWrapper}>
                                <DeleteIcon
                                    className={classes.locationDropdownIcon}
                                />
                            </div>
                            <div>{locale.locations.removeLocation}</div>
                        </div>
                    )}
                    {canShare(location, UserPermissions) && (
                        <div
                            className={classes.locationDropdownItem}
                            onClick={handleLocationShare(locationId)}>
                            <div
                                className={classes.locationDropdownIconWrapper}>
                                <ShareIcon
                                    className={classes.locationDropdownIcon}
                                />
                            </div>
                            <div>{locale.locations.assign}</div>
                        </div>
                    )}
                </Dropdown>
            )}
        </div>
    )
})

const canShare = (location, UserPermissions) => {
    const { is_assigned, customer_id, is_original } = location

    if (
        is_assigned &&
        UserPermissions.isOriginalEntity(customer_id) &&
        UserPermissions.location(customer_id).update
    ) {
        return true
    }
    if (is_original && UserPermissions.isAllOriginalGranted()) {
        return true
    }
    return false
}
